import * as angular from 'angular';

"use strict";
angular.module('Module1UserManagementService', []);

export default 'Module1UserManagementService'